
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'

// module components
import PreferencesFilters from '@/modules/PreferencesModule/components/PreferencesFilters/index.vue'

// types
import { Preference, GetPreferencesParams } from '@/core/types/preferences.types'

// realisations
import { preferences } from '@/core/realisations/preferences.realisation'

// constants
import { PreferencesColumns } from '@/core/constants/columns/Preferences.columns'

// classes
import { DataState } from '@/core/classes/DataState.class'
import { useFile } from '@/common/composable/useFile'

export default defineComponent({
    components: {
        FailedFetch,
        TheTable,
        TableScrollWrapper,
        PreferencesFilters,
        TheButton,
    },
    setup() {
        const data_state = reactive({
            preferences: new DataState<Preference>({}),
        })

        const filters_state = reactive({
            theme: null as number | null,
            email: null as string | null,
            name: null as string | null,
            source: null as number | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            //
            limit: 50,
        })

        const loadPreferences = async (page: number) => {
            data_state.preferences.pagination.current_page = page

            try {
                data_state.preferences.is_loading = true

                const params = {
                    page,
                    ...filters_state,
                }
                const response = await preferences.getList(params)

                data_state.preferences.list = response.data
                data_state.preferences.pagination.total_pages = response.meta.last_page
                data_state.preferences.pagination.total_items = response.meta.total

                data_state.preferences.is_failed = false
                data_state.preferences.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.preferences.failure.catchError(error)

                if (!data_state.preferences.failure.error_state.is_cancel) {
                    data_state.preferences.is_failed = true
                }
            } finally {
                if (!data_state.preferences.failure.error_state.is_cancel) {
                    data_state.preferences.is_loading = false
                }
            }
        }

        const onLimitChange = (limit: number) => {
            filters_state.limit = limit
            loadPreferences(data_state.preferences.pagination.current_page)
        }

        onBeforeMount(() => {
            loadPreferences(1)
        })

        const applyFilters = (params: GetPreferencesParams) => {
            filters_state.theme = params.theme
            filters_state.email = params.email
            filters_state.name = params.name
            filters_state.source = params.source
            filters_state.createdAtFrom = params.createdAtFrom
            filters_state.createdAtTo = params.createdAtTo

            loadPreferences(1)
        }

        const resetFilters = () => {
            filters_state.theme = null
            filters_state.email = null
            filters_state.name = null
            filters_state.source = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null

            loadPreferences(1)
        }

        const { saveFile } = useFile()
        const excel_state = reactive({
            is_loading: false,
        })

        const exportExcel = async () => {
            try {
                excel_state.is_loading = true

                const params = {
                    ...filters_state,
                }

                const response = await preferences.exportExcel(params)
                saveFile(response, 'Поставщики')
            } catch (e) {
                console.log(e)
            } finally {
                excel_state.is_loading = false
            }
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            const dateSecond = dateStr.split(' ')[1]
            return dateFirst.split('-').reverse().join('.') + ' ' + dateSecond
        }

        return {
            data_state,
            filters_state,
            excel_state,
            loadPreferences,
            applyFilters,
            resetFilters,
            onLimitChange,
            exportExcel,
            PreferencesColumns,
            formatDate,
        }
    },
})
